'use client';

import * as React from 'react';
import { cn } from '@shared/utils';
import { withPlatformComponents, WithPlatformComponents } from '../../platform';


/**
 * @group Components
 * 
 * @summary
 * First path of the Phila logo - right side shape
 * 
 * @example
 * ```typescript
 * <LogoPath1 size={32} className="text-brand" />
 * ```
 */
interface LogoPath1Props {
  size?: number;
  className?: string;
  color?: string;
}

const LogoComponent: React.FC<LogoPath1Props & WithPlatformComponents> = ({ 
  size = 32, 
  color = "#b7ebe1",
  className, 
  components 
}) => {
  const { Svg, Path } = components;
  // LogoPath1 bounding box (right side path)
  // Path spans roughly x: 184–449, y: 110–270
  const pathMinX = 180;
  const pathMinY = 105;
  const pathWidth = 275;
  const pathHeight = 170;
  const aspectRatio = pathWidth / pathHeight;
  
  const width = size * aspectRatio;
  const height = size;

  return (
    <Svg
      width={width}
      height={height}
      viewBox={`${pathMinX} ${pathMinY} ${pathWidth} ${pathHeight}`}
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      className={cn("inline-block", className)}
      style={{ verticalAlign: 'middle' }}
    >
      <Path className="cls-1" d="M389.81,259.67c31.57-8.5,53.31-34.76,59.04-70.06,4.28-26.37-4.52-53.69-23.56-72.95-33.84-34.24-89.85-35.36-125.1-2.49l-116.18,108.3c-1.48,1.38-.77,3.87,1.22,4.23,16.75,3.03,33.51,7.78,50.35,11.11,17.93,3.55,35.84,7.21,53.7,11.1,5.72,1.24,11.43,2.51,17.14,3.8,3.54.8,7.09,1.6,10.63,2.4,23.59,5.29,48.79,11.01,72.76,4.56Z"/>
      
    </Svg>
  );
}

export const LogoPath1 = withPlatformComponents(LogoComponent);